// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__mqHzL","noInteraction":"EventWrapper_noInteraction__3elSJ"};